module.exports = __webpack_public_path__ + "static/media/icon_space_b.5803fd92.svg";